import { NextPage } from 'next'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import FoldText from '~/components/FoldText'
import NotificationBar from '~/components/NotificationBar'
import Space from '~/components/Space'
import {
  IncomeExpensesArea,
  LonBuyBackArea,
  BuybackHistoryList,
} from './components'
import { useLocalStorage } from '~/hooks/useLocalStorage'
import {
  StyledBuybackContentWrapper,
  StyledBuybackWrap,
  StyledLonBuybackHeadContainer,
  StyledMainBuybackContainer,
} from './styled'
import { StyledTitleIcon } from '~/components/TradeMining/styled'
import IconBuyback from '~/assets/images/buyback-light.svg'

const Buyback: NextPage = () => {
  const { t } = useTranslation()
  const notificationLink =
    'https://snapshot.box/#/s:tokenlon.eth/proposal/0x3c5b2ade26417a0fcc66215e3a38dac07d46ef64bcc4adc19c465f4a71af5534'

  const [visitedNotification, setVisitedNotification] = useLocalStorage(
    'lon-mint-factor-change-notification-20250108-visited',
    false,
  )

  const handleNotificationLinkClick = () => {
    window.open(notificationLink, '_blank', 'noopener,noreferrer')
  }

  return (
    <StyledBuybackWrap>
      <Head>
        <title>{t('meta_lon_buyback_title')}</title>
        <meta name="description" content={t('meta_lon_buyback_description')} />
        <meta name="keywords" content={t('meta_lon_keywords')} />
      </Head>
      <Header />
      <StyledBuybackContentWrapper>
        <StyledMainBuybackContainer>
          <StyledLonBuybackHeadContainer>
            {!visitedNotification && (
              <>
                <NotificationBar
                  text={t('buyback_notification')}
                  handleClose={() => setVisitedNotification(true)}
                  handleLinkClick={handleNotificationLinkClick}
                />
                <Space height={40} />
              </>
            )}
            <div className="header">
              <StyledTitleIcon src={IconBuyback} />
              <h1 className="title">{t('buyback_page_title')}</h1>
            </div>
            <p className="description">
              <FoldText texts={[t('buyback_page_desc')]} />
            </p>
          </StyledLonBuybackHeadContainer>
          <IncomeExpensesArea />
          <LonBuyBackArea />
          <BuybackHistoryList />
        </StyledMainBuybackContainer>
      </StyledBuybackContentWrapper>
      <Footer />
    </StyledBuybackWrap>
  )
}

export default Buyback
